// Works out at 730 hours on average based on non leap years
const averageHoursPerMonth = (365 / 12) * 24;

export const calcMonthlyCost = (costPerHour: string) => {
  return (parseFloat(costPerHour) * averageHoursPerMonth).toFixed(2);
};
